<div class="glass-cards-container">
  @for (card of cards; track card.id) {
    <div class="glass-card" (click)="onCardClick(card)">
      <span class="glass-card-label">{{ card.label }}</span>
      <span
        class="glass-card-value"
        [class.has-issues]="card.hasIssue"
        [class.has-warning]="card.hasWarning">
        {{ card.value }}
      </span>
      <span class="material-icons glass-card-chevron">chevron_right</span>
    </div>
  }
</div>
